import React from 'react';

import { Alert, Typography } from 'vindi-ds-components';

function ErrorsAlert({ style, title, errors }) {
  if (errors.length !== 0) {
    return (
      <Alert style={style} severity='error'>
        <Typography variant='subtitle1'>{title}</Typography>
        {errors.join(', ')}
      </Alert>
    );
  }

  return null;
}

export default ErrorsAlert;
